// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import WarningFilledSvg from "@ant-design/icons-svg/lib/asn/WarningFilled";
import AntdIcon from "../components/AntdIcon";
const WarningFilled = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: WarningFilledSvg
    });
if (process.env.NODE_ENV !== "production") {
    WarningFilled.displayName = "WarningFilled";
}
export default /*#__PURE__*/ React.forwardRef(WarningFilled);
